/**
 * Read a CSS custom property from :root, returning its trimmed value.
 * Returns empty string in non-DOM environments (SSR-safe).
 *
 * Used by motion.config.ts and useClerkAppearance.ts to resolve design
 * tokens to concrete values for libraries that don't accept CSS vars.
 */
export const cssVar = (name: string): string => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return '';
  }
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
};
